// extracted by mini-css-extract-plugin
export default {"whichConnectMessage":"WhichConnectMessage_whichConnectMessage__dIvaO"};